import config from '@app/config'
import { ConfigurationState } from '@app/store/configuration'
import {
  DEFAULT_LANGUAGE,
  getPortalUrlByCulture,
  getUserLanguage,
} from '@app/utils/regional'

import { isBuyerView } from './isBuyerView'

export const getAppUrl = (
  configuration: ConfigurationState,
  path: string = ''
): string => {
  const buyerView = isBuyerView()
  const buyerPortalUrl = buyerView
    ? getPortalUrlByCulture(getUserLanguage()) ||
      getPortalUrlByCulture(DEFAULT_LANGUAGE)
    : undefined

  const isBackOffice =
    configuration.isBackOffice ?? config.identity.isBackOffice ?? buyerView
  const website = configuration.website || config.identity.website || ''

  const appUrl = isBackOffice
    ? buyerPortalUrl || website || document.location.origin
    : website || document.location.origin

  return `${appUrl}${path}`
}
